import { render, staticRenderFns } from "./PageVideo.vue?vue&type=template&id=6e8041a4"
import script from "./PageVideo.vue?vue&type=script&lang=js"
export * from "./PageVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8041a4')) {
      api.createRecord('6e8041a4', component.options)
    } else {
      api.reload('6e8041a4', component.options)
    }
    module.hot.accept("./PageVideo.vue?vue&type=template&id=6e8041a4", function () {
      api.rerender('6e8041a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/video/PageVideo.vue"
export default component.exports